<!--AFFICHAGE BLOC GOOGLE -->
<template>
  <v-col md="12" class="pa-3 d-flex flex-column" v-if="this.condition()" >
                  <a class="anchor" id="blocfinance"></a>

    <v-card elevation="2">

      <v-card-title> <v-icon dense left>mdi-currency-eur</v-icon> Eléments financiers</v-card-title>
      <v-card-text>
      <div>Le risque de défaillance est un score qui permet de cibler les entreprises avec un fort risque de contentieux dans les 3 prochaines années.
        Si ce score est élevé, il est recommandé de porter une attention particulière à la situation de l'entreprise.

        </div></v-card-text>
      <v-card-text>

      <v-simple-table>
        <tbody>
        <!-- <tr>
          <td>
            Risque de défaillance :
          </td>
          <td v-if="this.defaillance!=null">
            <PictoItem v-bind:data="defaillancePicto" v-if="this.defaillancePicto!=null"/>
            <br>
              L'entreprise a un risque de défaillance élevé, parce que :
            <br>

            <ul>
              <li v-for="item in defaillance.features_with_default" :key="item.motif">
               {{ item.valeur }}
              </li>
            </ul>
          </td>
           <td v-if="this.defaillance==null">
            Aucun risque de défaillance n'a été détecté. Cependant veillez à analyser la situation de l'entreprise.
          </td>
        </tr> -->
        <tr>
          <td>
            Impayés :
          </td>
          <td>
            <div>Evènements sur les 2 dernières années:</div>
            <ul><li><b>Plus grave incident de paiement: </b><PictoItem v-bind:data="impayesPicto" v-if="this.impayesPicto!=null"/></li>
              <span v-html="impayesMessage" v-if="this.impayesPicto!=null" /></ul>
          </td>
        </tr>
        <SimpleTr
            v-bind:var="financeIndicateurs"
            data="defaillanceGratuit"
            field="libelle"
            prefix="Alerte : "
        ></SimpleTr>

        <!-- <tr v-if="this.scorecredit">

          <td>Score de crédit</td>
          <td>
            <PictoItem v-bind:data="scorecreditPicto"/>
            {{ this.scorecredit.libelle }}
          </td>

        </tr>
        <tr v-if=" this.scorecredit && this.scorecredit.valeur">
          <td>Covid</td>
          <td>
            {{ this.scorecredit.valeur.covid_impact }}
          </td>
        </tr>
        <tr v-if=" this.scorecredit && this.scorecredit.valeur">
          <td>Délais règlement secteur</td>
          <td>
            {{ this.scorecredit.valeur.delaiReglementFournisseurSecteur }}
          </td>
        </tr>
        <tr v-if="this.scorecredit_commentaire">
          <td>Score de crédit (commentaire)</td>
          <td>
            <ul >
              <li v-for="(item,i) in scorecredit_commentaire" :key="i">
                {{ item }}
              </li>
            </ul>


          </td>
        </tr>

        <tr v-if="this.scorecredit">
          <td>Evolution du score</td>
          <td>
            <D3LineChart :config="chart_config" :datum="scorecredit_historique"></D3LineChart>
          </td>
        </tr> -->

        <SimpleTr
            v-bind:var="financeDonnees"
            data="qualibatChiffreAffaires"
            field="libelle"
            prefix="Chiffre d'affaire (Qualibat): "
            suffix=" €"
        ></SimpleTr>

         <SimpleTr
            v-bind:var="financeDonnees"
            data="capitalSocialInpi"
            field="libelle"
            prefix="Capital social : "
        ></SimpleTr>
        <SimpleTr
            v-bind:var="financeDonnees"
            data="qualibatCapital"
            field="libelle"
            prefix="Capital : (Qualibat)"
            suffix=" €"
        ></SimpleTr>
        <SimpleTr
            v-bind:var="financeDonnees"
            data="qualibatSituationFiscaleSociale"
            field="valeur"
            prefix="Situation fiscale à jour au (Qualibat) : "
        ></SimpleTr>


        </tbody>
      </v-simple-table>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import SimpleTr from "@/components/layout/SimpleTr.vue";
import PictoItem from "@/components/layout/PictoItem.vue";
// import {D3LineChart} from 'vue-d3-charts';


export default {
  name: "Finance",
  props: [""],
  components: {
    SimpleTr, PictoItem
  },

  data() {
    return {
      chart_config: {
        values: ['average_score', 'average_score_activity'],
        color: {
          scheme: ['#3455eb', '#bfbfbf']
        },
        key: 'date',
        date: {
          key: 'date',
          inputFormat: '%m %Y',
          outputFormat: '%m %Y',
        },
        axis: {
          yFormat: '.1s',
          yTicks: 6,
          xTicks: 5,
          yTitle: "Score"
        },
        points: {
          visibleSize: 4,
          hoverSize: 6,
        },
        tooltip: {
          labels: ['Score', 'Score sectoriel']
        },
        curve: "curveLinear",
        transition: {
          ease: 'easeBounceOut',
          duration: 1000
        }
      },
      sortBy: 'year',
      sortDesc: false,
      scorecredit: "",
      scorecredit_historique: [],
      scorecredit_commentaire: "",
      mois: {
        "01": "janvier",
        "02": "février",
        "03": "mars",
        "04": "avril",
        "05": "mai",
        "06": "juin",
        "07": "juillet",
        "08": "aout",
        "09": "septembre",
        "10": "octobre",
        "11": "novembre",
        "12": "décembre"
      }
    }
  },
  mounted() {
  },
  created() {

   this.impayeColor = {
       "PREAVIS": "yellow",
       "MED": "orange",
       "SUSP+": "red",
       "Aucun": "green",
       "indéfini": "grey",
       "Suspension_Garanties ou plus":"red",
      "Preavis" : "yellow"
     }
  },
  computed: {
    headers() {
      return [
        {
          text: "Date",
          align: "start",
          sortable: false,
          value: "date",
          fixed: true,
          width: "10px",
        },

        {
          text: "Score",
          value: "average_score",
          align: "end",
          fixed: true,
          width: "100px",
        },
        {
          text: "Score secteur",
          value: "average_score_activity",
          align: "end",
          fixed: true,
          width: "100px",
        }]
    },
    financeDonnees: function () {
      return this.$store.getters.getbloc("finance", "donnees");
    },
    identite: function () {
      return this.$store.getters.getbloc("identite", "donnees");
    },
    financeIndicateurs: function () {
      return this.$store.getters.getbloc("finance", "indicateurs");
    },
    bilanGratuit: function () {
      return this.$store.getters.getbloc(
          "finance",
          "indicateurs",
          "bilanGratuit"
      );
    },
    scorecreditPicto: function () {
      if (this.scorecredit && this.scorecredit.valeur) {
        return {
          "id": "blocfinance",
          "tooltip": "Score de crédit : " + this.scorecredit.libelle,
          "icon": "credit_card",
          "color": this.scorecredit.valeur.couleur,
          "text": this.scorecredit.valeur.note
        }
      } else {
        return null
      }
    },
    defaillance: function () {
      var defaillance =  this.$store.getters.getbloc("finance", "indicateurs", "score_defaillance", null, "valeur")
      if (defaillance && defaillance.warning) {
        return defaillance
      } else {
        return null
      }
    },
    defaillancePicto: function () {
      var defaillance = this.$store.getters.getbloc("finance", "indicateurs", "score_defaillance")

      if (defaillance && defaillance.valeur != null && defaillance.valeur.warning) {
        return {
          "id": "blocfinance",
          "tooltip": "Risque de défaillance : " + defaillance.libelle,
          "icon": "mdi-credit-card-remove-outline",
          "color": "grey",
          "text": defaillance.libelle
        }
      } else {
        return null
      }
    },
    impayesMessage: function () {
      var impayes = this.$store.getters.getbloc("finance", "donnees", "impayes", null, "valeur")
      if (impayes) {
        return !impayes.historique_2_ans ? "Pas d'historique disponible" : `<li><b>Nombre d'incidents</b>: ${impayes.nombre_incident}</li>
        <li><b>Date du dernier incident</b>: ${impayes.date_dernier_inc}</li>`
      } else {
        return "Aucune données"
      }
    },
    impayesPicto : function() {
      var impayes = this.$store.getters.getbloc("finance", "donnees", "impayes")
       if (impayes && impayes.valeur != null) {
         return {
           "id": "blocfinance",
           "tooltip": "Historique Impayés : "+ (impayes.valeur.plus_grand_retard == "MED" ? "Mise en demeure" : impayes.valeur.plus_grand_retard),
           "icon": "mdi-currency-eur-off",
           "color": this.impayeColor[impayes.valeur.plus_grand_retard],
           "text": (impayes.valeur.plus_grand_retard == "MED" ? "Mise en demeure" : impayes.valeur.plus_grand_retard)
         }
       } else {
          return {
           "id": "blocfinance",
           "tooltip": "Historique Impayés : inconnu",
           "icon": "mdi-currency-eur-off",
           "color":"grey",
            "text": "indéfini"
          }
       }
    },

  },
  methods: {
    condition() {
      return (
          this.$store.getters.condition("finance", "donnees") ||
          this.$store.getters.condition("finance", "indicateurs")
      );
    },
    prepareScoreData() {
      var score = this.$store.getters.getbloc(
          "finance",
          "indicateurs",
          "score_credit_detail"
      );
      if (score == null) {
        score = this.$store.getters.getbloc(
            "finance",
            "indicateurs",
            "score_credit"
        );
      }
      this.scorecredit = score
      this.scorecredit_historique=[]
      this.scorecredit_commentaire = null
      if (score && score.valeur) {
        this.scorecredit_historique = score.valeur.historique.map(x => x ? {...x, date: x.month + " " + x.year} : x)
        var commentaires = score.valeur.commentaire
        if (commentaires) {
          var msg = []
          Object.keys(commentaires).forEach(function (key) {
            msg.push(commentaires[key])
          });
          this.scorecredit_commentaire = msg
        }
        if (score.valeur.resume) {
          this.scorecredit_commentaire.push(score.valeur.resume)
        }
      }


    },

  },
  beforeUpdate() {
    this.prepareScoreData()
  },
  beforeMount() {
    this.prepareScoreData()
  }

};
</script>

<style lang="scss">
.svg-demo {
  &__text {
    color: red;
  }
}

.chart {
  &--linechart {
    font-size: 10px;
  }

  &__point--linechart {
    /* your styles */
  }

  &__line--linechart {
    /* your styles */
    stroke-width: 3;
  }
}

</style>
